import React, { useState, useEffect } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import {
  HomeIcon,
  UsersIcon,
  CreditCardIcon,
  CurrencyDollarIcon,
  ArrowPathIcon,
  BanknotesIcon,
  ChartBarIcon,
  DocumentChartBarIcon,
  Cog6ToothIcon,
  UserGroupIcon,
  BuildingOfficeIcon,
} from '@heroicons/react/24/outline';
import { useAuth } from '../../contexts/AuthContext';
import agencyService from '../../services/agencyService';
import tenantService from '../../services/tenantService';
const navigation = [
  { name: 'Tableau de bord', href: '/', icon: HomeIcon },
  { name: 'Clients', href: '/clients', icon: UsersIcon },
  { name: 'Comptes Épargne', href: '/accounts', icon: CreditCardIcon },
  { name: 'Prêts', href: '/loans', icon: CurrencyDollarIcon },
  { name: 'Remboursements', href: '/repayments', icon: ArrowPathIcon },
  { name: 'Caisse', href: '/cash', icon: BanknotesIcon },
  { name: 'Agences', href: '/agencies', icon: BuildingOfficeIcon },
  { name: 'Tableau de bord TENANT', href: '/tenant/dashboard', icon: ChartBarIcon },
  { name: 'Utilisateurs', href: '/users', icon: UserGroupIcon },
  { name: 'Membres fondateurs', href: '/founders', icon: UserGroupIcon },
  { name: 'Rapports', href: '/reports', icon: DocumentChartBarIcon },
  { name: 'Analytiques', href: '/analytics', icon: ChartBarIcon },
  { name: 'Paramètres', href: '/settings', icon: Cog6ToothIcon },
];

const Sidebar = () => {
  const location = useLocation();
  const { hasPermission ,user} = useAuth();
 // const { user, logout } = useAuth();
 const [agencyData, setAgencyData] = useState(null);
  const [tenantData, setTenantData] = useState(null);
  const roleName = user?.role?.name?.toLowerCase() || '';
  const isTenantCreatorOnly = roleName === 'tenant_creator' || (
    hasPermission('create_tenant') &&
    !hasPermission('view_clients') &&
    !hasPermission('system_settings')
  );
  const globalNavigation = [
    { name: 'Dashboard Global', href: '/global/dashboard', icon: ChartBarIcon },
    { name: 'Tenants', href: '/global/settings', icon: BuildingOfficeIcon },
  ];
  const filteredNavigation = (isTenantCreatorOnly ? globalNavigation : navigation).filter(item => {
    if (item.name === 'Comptes Épargne' && !hasPermission('view_accounts')) return false;
    if (item.name === 'Comptes Épargne' && tenantData?.institution_config?.savings_enabled === false) return false;
    if (item.name === 'Prêts' && tenantData?.institution_config?.credit_enabled === false) return false;
    if (item.name === 'Caisse' && tenantData?.institution_config?.cash_register_required === false) return false;
    if (item.name === 'Agences' && tenantData?.institution_config?.multi_agency_enabled === false) return false;
    if (item.name === 'Agences' && !hasPermission('manage_agencies')) return false;
    if (item.name === 'Utilisateurs' && !hasPermission('manage_users')) return false;
    if (item.name === 'Membres fondateurs' && !hasPermission('system_settings')) return false;
    return true;
  });
////////////////////////////////
useEffect(() => {
  const fetchSidebarContext = async () => {
    try {
      const [agData, tenantData] = await Promise.all([
        user?.agency_id ? agencyService.getAgency(user.agency_id) : Promise.resolve(null),
        isTenantCreatorOnly ? Promise.resolve(null) : tenantService.getCurrentTenant()
      ]);
      setAgencyData(agData);
      setTenantData(tenantData);
      // Set form values
    } catch (error) {
     // showError('Erreur lors du chargement du client');
  
    } finally {
    }
  };
  fetchSidebarContext();
}, [user?.agency_id, isTenantCreatorOnly]);
////////////////////////////
  return (
    <div className="flex flex-col flex-1 bg-gray-800">
      <div className="flex-1 flex flex-col pt-5 pb-4 overflow-y-auto">
        <div className="flex items-center flex-shrink-0 px-4">
          <div className="flex items-center">
            <CurrencyDollarIcon className="h-8 w-8 text-white" />
            <span className="ml-2 text-white text-xl font-bold">
              {isTenantCreatorOnly ? 'PRONTO Core' : `${tenantData ? tenantData.name : ''}${agencyData ? ` - ${agencyData.name}` : ''}`}
            </span>
          </div>
        </div>
        <nav className="mt-5 flex-1 px-2 space-y-1">
          {filteredNavigation.map((item) => {
            const isActive = location.pathname === item.href || (
              item.href === '/global/settings' && location.pathname.startsWith('/global/settings/')
            );
            return (
              <NavLink
                key={item.name}
                to={item.href}
                className={`
                  group flex items-center px-2 py-2 text-sm font-medium rounded-md
                  ${isActive
                    ? 'bg-gray-900 text-white'
                    : 'text-gray-300 hover:bg-gray-700 hover:text-white'
                  }
                `}
              >
                <item.icon
                  className={`
                    mr-3 flex-shrink-0 h-6 w-6
                    ${isActive ? 'text-white' : 'text-gray-400 group-hover:text-white'}
                  `}
                  aria-hidden="true"
                />
                {item.name}
              </NavLink>
            );
          })}
        </nav>
      </div>
    </div>
  );
};

export default Sidebar;
